import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { authActions } from "../../../redux/actions";
import Button from "../../../component/button/Button";
import ErrorRender from "../../../component/request/ErrorRender";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import P from "../../../component/smallComponents/P";
import SelectInput from "../../../component/input/SelectInput";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import TextInput from "../../../component/input/TextInput";
import {
  getBrowserDetails,
  isSuperAdmin
} from "../../../constant/helper/helper";

const LoginTypes = {
  Employee: "Employee",
  Worker: "Worker"
};

const LoginPage = () => {
  const localStorageLocationName = localStorage.locationName;
  const localStorageModuleType = localStorage.moduleType;
  const localStorageLocationId = localStorage.locationId;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errors, setErrors] = useState("");
  const [workerId, setWorkerId] = useState("");
  const [workerPassword, setWorkerPassword] = useState("");
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [loginType, setLoginType] = useState(LoginTypes.Employee);
  const {
    authError,
    authLoading,
    isAuthenticated,
    currentUser,
    authStatus
  } = useSelector((state) => state.auth);

  const showOptions = Object.values(LoginTypes).map((type, index) => (
    <option value={type} key={index}>
      {type}
    </option>
  ));

  const onSubmit = async (e) => {
    e.preventDefault();
    const browserDetail = await getBrowserDetails();
    const os = browserDetail.os.name;
    const browser = browserDetail.browser.name;

    const userInfo = {
      workerId,
      workerPassword,
      ipAddress: localStorage?.publicIpAdd,
      deviceDetails: os + "-" + browser,
      latitude: localStorage.latitude,
      longitude: localStorage.longitude
    };
    dispatch(authActions.setAuthLoading(true));
    dispatch(authActions.clearAuthErrors());
    dispatch(authActions.clearAuthResult());
    dispatch(authActions.loginUser(userInfo, loginType));
  };

  useEffect(() => {
    setErrors(authError);
  }, [authError]);

  useEffect(() => {
    setTimeout(() => {
      dispatch(authActions.clearAuthErrors());
      dispatch(authActions.clearAuthResult());
      dispatch(authActions.setAuthLoading(false));
    }, 1000);

    return () => {
      dispatch(authActions.clearAuthErrors());
      dispatch(authActions.clearAuthResult());
      dispatch(authActions.setAuthLoading(false));
    };
  }, []);

  useEffect(() => {
    // console.log(currentUser);
    setTimeout(() => {
      if (isAuthenticated && isSuperAdmin(currentUser)) {
        navigate(
          `/dashboard/${currentUser.workerFirstName}/${currentUser.workerDepartment}`
        );
      } else if (
        isAuthenticated &&
        localStorageLocationName !== "" &&
        localStorageModuleType !== "" &&
        typeof localStorageLocationName !== "undefined" &&
        typeof localStorageModuleType !== "undefined"
      ) {
        navigate(
          `/dashboard/${currentUser.workerFirstName}/${currentUser.workerDepartment}`
        );
      } else if (isAuthenticated) {
        navigate("/auth/select-project");
      }
    }, 1000);
  }, [
    localStorageLocationName,
    localStorageModuleType,
    isAuthenticated,
    localStorageLocationId,
    currentUser
  ]);

  return (
    <div className="authentication-bg">
      <div className="account-pages mt-5 mb-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="card">
                <div className="card-header pt-4 text-center bg-dark">
                  <span>
                    <img
                      src="https://i.imgur.com/ahvlkuu.png"
                      alt=""
                      height="35"
                    />
                  </span>
                </div>
                <div className="card-body p-4 bg-dark">
                  <div className="text-center w-75 m-auto">
                    <HeaderTag
                      type="h4"
                      title="Sign In"
                      isClassName={true}
                      className="text-white text-center mt-0 font-weight-bold"
                    />
                    <P
                      title="Enter your Employee ID and password to access
                      Dashboard panel."
                    />
                  </div>
                  <form onSubmit={onSubmit}>
                    <TextInput
                      type={"text"}
                      required={true}
                      textWhite={true}
                      value={workerId}
                      label={"Employee Id"}
                      htmlFor={"workerId"}
                      placeholder={"Enter your Employee ID"}
                      onChange={(e) => setWorkerId(e.target.value)}
                    />
                    <TextInput
                      required={true}
                      textWhite={true}
                      htmlFor={"password"}
                      value={workerPassword}
                      label={"Password"}
                      placeholder={"Enter your password"}
                      type={isShowPassword ? "text" : "password"}
                      onChange={(e) =>
                        setWorkerPassword(e.target.value)
                      }
                    />
                    <SelectInput
                      required={true}
                      textWhite={true}
                      isLabeled={true}
                      value={loginType}
                      label="Login Type"
                      onChange={(e) => setLoginType(e.target.value)}
                    >
                      {showOptions}
                    </SelectInput>
                    <div className="form-group mb-3">
                      <input
                        type="checkbox"
                        value={isShowPassword}
                        onChange={(e) =>
                          setIsShowPassword(!isShowPassword)
                        }
                      />
                      <label className="ml-2 text-white">
                        Show Password
                      </label>
                    </div>

                    <div className="form-group mb-0 text-center mt-3">
                      {authLoading ? (
                        <SpinnerButton />
                      ) : authStatus === 1 ? null : (
                        <Button
                          title={"Log In"}
                          icon="mdi mdi-login"
                          type="submit"
                          isBackgroundColor={true}
                        />
                      )}
                    </div>
                    {errors ? <ErrorRender errors={errors} /> : null}
                  </form>
                </div>
              </div>
            </div>
            <div className="text-center w-75 m-auto">
              <P
                title="This site is available for Authorized users. If you
                      are not authorized user, please  don't attempt to
                      login. All activities performed on this site are
                      logged and monitored."
              />
            </div>
          </div>
        </div>
      </div>
      <footer className="footer footer-alt">
        <p>
          Developed and maintain by{" "}
          <strong className="text-dark">VITORSCAPE</strong>
        </p>
        {/* <p>
          Copyright ©{" "}
          <strong className="text-dark">VITORSCAPE</strong>
        </p> */}
      </footer>
    </div>
  );
};

export default LoginPage;
